<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.tipos"
                            @change="handleTipoChange"
                            default-option-text="Todos"
                            label="Tipo"
                            show-default-option
                            text-field="nome"
                            v-model="model.tipoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.grupos"
                            @change="handleGrupoChange"
                            default-option-text="Todos"
                            label="Grupo"
                            show-default-option
                            text-field="nome"
                            v-model="model.grupoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.valores"
                            @change="handleValorChange"
                            default-option-text="Todos"
                            label="Valor Sitap"
                            show-default-option
                            text-field="valorSigtap"
                            v-model="model.valorId"
                            value-field="valorId"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="data">
            <rkm-area
                no-margin-top
                title="Resultado"
            >               
                <template v-slot:trailing>

                    <rkm-dropdown
                        class="mr-2"
                        color="primary"
                        no-caret
                        small
                        title="Colunas"
                        cols="1"
                        v-rkm-tooltip.hover
                        menu-class="auto-scroll"
                    >
                        <template v-slot:button-content>
                            <rkm-icon icon="columns" />
                        </template>
                        <rkm-form-checkbox
                            :indeterminate="indeterminate"
                            @change="selectAll"
                            class="mx-2"
                            v-model="selectedAll"
                        >
                            Todas
                        </rkm-form-checkbox>
                        <rkm-form-checkbox-group
                            :options="optionalColumns"
                            class="mx-2"
                            stacked
                            text-field="label"
                            v-model="selectedCols"
                            value-field="key"
                        />
                    </rkm-dropdown>

                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="fields"
                    :items="data.itens"
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    @sort-changed="onSortChanged"
                    hide-filters
                />
            </rkm-area>            
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, formats, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.parametrizacao'),
            impressao: this.getConectaSusRepository('impressao.parametrizacao'),
            relatorioExameCadastrado: this.getConectaSusRepository('parametrizacao.relatorioExameCadastrado'),
        }

        this.load()
    },
     computed: {
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
    },
    data() {
        return {
            additionals: null,
            form: null,
            data: null,
            columns: [
                {key: 'nomeExame', label: 'Exame', sortable: true, fixed: true },
                {key: 'nomeTipo', label: 'Tipo', sortable: true, fixed: true },
                {key: 'nomeGrupo', label: 'Grupo', sortable: true, fixed: true },
                {key: 'codigoSigtap', label: 'Código', sortable: true, fixed: true }, 
                {key: 'nomeProcedimento', label: 'Descrição Procedimento Sigtap', sortable: true, fixed: false},
                {key: 'valorSigtap', label: 'Valor Sitap', sortable: true, fixed: true },
                {key: 'valorExame', label: 'Valor Exame', sortable: true, fixed: false},
                {key: 'validadeExame', label: 'Validade Exame', sortable: true, fixed: false},
            ],
            model: null,
            others: {moment},
            sortBy: 'nomeExame',
            sortDesc: false,
            selectedAll: false,
            indeterminate: false,
            selectedCols: [],
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioExameCadastrado.create()
                .then((response) => {
                    this.additionals = response.data.additionals
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                tipoId: this.model.tipoId,
                grupoId: this.model.grupoId,
                valorId: this.model.valorId,
            }

            this.setLoading()

            this.repositories.relatorioExameCadastrado.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.data = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.grupos = []
            this.form.valores = []

            this.model.tipoId = null
            this.model.grupoId = null
            this.model.valorId = null
            this.data = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                tipoId: this.model.tipoId,
                grupoId: this.model.grupoId,
                valorId: this.model.valorId,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
                selectedCols: this.fields.map(f => ({
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class
                }))
            }

            this.repositories.impressao.relatorioExameCadastrado(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            const request = {
                tipoId: this.model.tipoId,
                grupoId: this.model.grupoId,
                valorId: this.model.valorId,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
                selectedCols: this.fields.map(f => ({
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class
                }))
            }

            this.repositories.exportacao.relatorioExameCadastrado(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handleTipoChange(value) { 
            this.form.grupos = []
            this.model.grupoId = null

            this.form.valores = []            
            this.model.valorId = null

            this.data = null

            const request = {
                listar: 'grupos',
                tipoId: value,   
            }

            this.setLoading()

            this.repositories.relatorioExameCadastrado
                .list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.grupos = response.data.grupos ?? []
                    this.form.valores = response.data.valores ?? [] 
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleGrupoChange(value) { 
            this.form.valores = []           
            this.model.valorId = null
            this.data = null

            const request = {
                listar: 'valores',
                grupoId: value,   
            }

            this.setLoading()

            this.repositories.relatorioExameCadastrado
                .list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.valores = response.data.valores ?? []
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleValorChange() {
            this.data = null
        },
        onSortChanged(context) {
            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
    },
    mixins: [error, file, formats, repository, stringCase],
}
</script>